import { isZipFile } from 'components/CreateUpdateSiteModal/interface'
import { createFileInput } from './general'
import toast from 'react-hot-toast'
import { MIXED_FOLDER_ERROR_MSG, MIXED_ZIP_ERROR_MSG } from '../constants'

export const processAdditionalFiles = async ({
  filesToAdd = [],
  files = [],
  fileSelected = null,
  customValidation = () => true
}) => {
  if (!filesToAdd.length) return null

  const validFiles = []

  for (const fileToAdd of filesToAdd) {
    if (!fileToAdd.path) {
      fileToAdd.path = fileToAdd.name
    }

    const allCurrentFiles = [fileSelected, ...files, ...validFiles].filter(Boolean)

    const hasZip = allCurrentFiles.some((f) => !!f && isZipFile(f.type || f.fileType))
    const addingZip = isZipFile(fileToAdd.type || fileToAdd.fileType)

    if ((hasZip && fileToAdd) || addingZip) {
      if (allCurrentFiles.length > 0 || filesToAdd.length > 1) {
        const hasFolder = allCurrentFiles.some((f) => f && f.isFolder) || (fileToAdd && fileToAdd.isFolder)
        if (hasFolder) {
          toast.error(MIXED_FOLDER_ERROR_MSG)
        } else {
          toast.error(MIXED_ZIP_ERROR_MSG)
        }
        return null
      }
    }

    const isDuplicate = allCurrentFiles.some(
      (existingFile) => existingFile.name.toLowerCase() === fileToAdd.name.toLowerCase()
    )

    if (isDuplicate) {
      alert(`File "${fileToAdd.name}" already exists. Please upload files with different names.`)
      return null
    }

    const isValid = await Promise.resolve(customValidation(fileToAdd, allCurrentFiles))
    if (!isValid) {
      return null
    }

    validFiles.push(fileToAdd)
  }

  return validFiles
}

export const promptForAdditionalFiles = ({
  files = [],
  fileSelected = null,
  acceptedFilesType = '*/*',
  onFilesValidated,
  customValidation = () => true
}) => {
  const input = createFileInput(acceptedFilesType)

  const handleChange = async (event) => {
    const filesToAdd = Array.from(event.target.files || [])

    const validFiles = await processAdditionalFiles({
      filesToAdd,
      files,
      fileSelected,
      customValidation
    })

    if (validFiles && validFiles.length > 0) {
      onFilesValidated(validFiles)
    }
    input.removeEventListener('change', handleChange)
    input.remove()
  }

  requestAnimationFrame(() => {
    input.addEventListener('change', handleChange)

    input.click()
  })
}

export const removeFileFromUploadState = ({
  files = [],
  fileSelected = null,
  fileToRemove = null,
  isSelectedFile = false,
  onUpdateFiles
}) => {
  if (isSelectedFile && files.length > 0) {
    onUpdateFiles({ newSelectedFile: files[0], newFiles: files.slice(1), removedFile: fileToRemove })
  } else if (isSelectedFile) {
    onUpdateFiles({ newSelectedFile: undefined, newFiles: [], removedFile: fileToRemove })
  } else {
    const updatedFiles = files.filter((f) => f.name !== fileToRemove.name)
    onUpdateFiles({ newSelectedFile: fileSelected, newFiles: updatedFiles, removedFile: fileToRemove })
  }
}
